export const Colors = {
    disabledText : '#D8DADA',
    activeDefault :'#0077B4',
    foregroundSecondaryText : '#747474',
    foregroundSecondarybackground : '#F2F2F2',
    error: '#C44904',
    black: '#000000',
    white: '#ffffff',
    grayBorder: '#e0e0e0',
    nickel: '#747676',
    validInput: "#008330" ,
    whiteSmoke: "#F6F6F6",
    dimGray: "#6F7171",
    lightYellow: "#FFF9DE",
    lightPeach: "#FFECE0",
    green: '#008331',
    frenchBlue: '#006FC1'
  }